
export default function AboutSection() {
  return (
    <section className="py-20 bg-stone-100">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-stone-800 mb-6">
                Rólam
              </h2>
              <div className="space-y-6 text-stone-700 leading-relaxed">
                <p className="text-lg">
                  <strong className="text-stone-800">Grendorf Zoltán vagyok, svédmasszőr.</strong> Közvetlen, ügyfélközpontú hozzáállással dolgozom.
                </p>
                <p className="text-lg">
                  Hiszem, hogy a masszázs nem luxus, hanem segítség. A stressz, az ülőmunka és a feszültség mind fizikailag, mind lelkileg hat ránk.
                </p>
                <p className="text-lg font-medium text-amber-700">
                  Célom, hogy a vendégeim feltöltődve, megkönnyebbülve távozzanak.
                </p>
              </div>
            </div>
            
            <div className="relative flex justify-center items-start">
              <div className="w-full" style={{ maxWidth: '480px' }}>
                <img
                  src="https://static.readdy.ai/image/5f12d79e9d850055a25ce719729b8deb/aeab23f87efb47d0b28faa822798dfac.jpeg"
                  alt="Masszázs kezelés"
                  className="rounded-lg shadow-lg w-full h-auto"
                  style={{ display: 'block' }}
                />
              </div>
              <div className="absolute -bottom-6 -right-6 bg-amber-100 p-6 rounded-lg shadow-lg">
                <div className="text-center">
                  <div className="text-2xl font-bold text-amber-700">1+</div>
                  <div className="text-sm text-stone-600">év tapasztalat</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
